import {OddsApiModel} from "./odds.api-model";
import {BookmakerDomainModel} from "../../bookmaker/models/bookmaker-domain-model";
import {RateOptionDomainModel} from "../rate-option/models/rate-option.domain-model";
import {BaseDomainModel} from "../../../../infrastructure/models/base-domain-model";
import {ExtraLinkDomainModel} from "../extra-link/models/extra-link.domain-model";
import {LineTypeDomainModel} from "../line-type/line-type.domain-model";
import {makeObservable, observable} from 'mobx';
import {RateOptionApiModel} from "../rate-option/models/rate-option.api-model";

export class OddsDomainModel extends BaseDomainModel {
  apiModel: OddsApiModel;
  bookmaker: BookmakerDomainModel;
  @observable options: Array<RateOptionDomainModel>;
  gameId: Number;
  lineId: Number;
  lineTypeId: Number;
  lineType: LineTypeDomainModel;
  trackingUrl: String;
  link: String;

  constructor(apiModel: OddsApiModel, bookmaker: BookmakerDomainModel) {
    super(apiModel);

    this.bookmaker = bookmaker || new BookmakerDomainModel(apiModel.bookmaker);
    this.gameId = apiModel.gameId;
    this.lineId = apiModel.lineId;
    this.lineTypeId = apiModel.lineTypeId;
    this.lineType = new LineTypeDomainModel(apiModel.lineType);
    this.trackingUrl = apiModel.trackingUrl;
    this.link = apiModel.link;
    this.extraLinks = apiModel.extraLinks?.map(extraLink => new ExtraLinkDomainModel(extraLink));
    this.options = apiModel.options.map((rate: RateOptionApiModel) => new RateOptionDomainModel(rate));

    makeObservable(this);
  }

  update(model: OddsDomainModel) {
    super.update(model);

    if(model) {
      this.options = model.options;
    }
  }
}
